import { MobilePrimaryDomainNotRegistered } from '../../Components/StatusesOverrides/LoggedInMobile/MobilePrimaryDomainNotRegistered';
import { MobileSubdomainRootTaken } from '../../Components/StatusesOverrides/LoggedInMobile/MobileSubdomainRootTaken';
import { divertConnectToEntriEligibility } from './connectEntriEligibility';
import { buildMobileConnectStatus } from './mobileConnectStatus';
import { buildMobileDomainTakenInWixStatus, buildMobileSubdomainTakenInWixStatus } from './mobileDomainTakenInWixStatus';
import { buildMobileEntriDivertStatus } from './mobileEntriDivertStatus';
export const buildMobileSubdomainRootIsNotConnectedStatus = buildMobileEntriDivertStatus({
  divert: divertConnectToEntriEligibility,
  StatusComponent: MobilePrimaryDomainNotRegistered
});
export const buildMobileRootDomainIsConnectedByPointingStatus = buildMobileEntriDivertStatus({
  divert: divertConnectToEntriEligibility,
  StatusComponent: MobileSubdomainRootTaken
});
export const buildMobileEntriStatusesOverrides = handlers => ({
  connect: buildMobileConnectStatus(handlers),
  transfer: buildMobileConnectStatus(handlers),
  domainTakenInWix: buildMobileDomainTakenInWixStatus(handlers),
  subdomainTakenInWix: buildMobileSubdomainTakenInWixStatus(handlers),
  subdomainRootIsNotConnected: buildMobileSubdomainRootIsNotConnectedStatus(handlers),
  rootDomainIsConnectedByPointing: buildMobileRootDomainIsConnectedByPointingStatus(handlers)
});
//# sourceMappingURL=mobileEntriStatusesOverrides.js.map